export type ClaimType = 'road' | 'work' | 'public' | 'other'
export type YesNo = '' | 'yes' | 'no'
export type WorkImpact = '' | 'Not at all' | 'Partially' | 'I cannot work'
export type CalculatorStatus = 'idle' | 'submitting' | 'success'

export interface CalculatorFormData {
  name: string
  dateOfBirth: string
  mobile: string
  email: string
  injuryDate: string
  occurredInWA: YesNo
  injuries: string
  surgery: YesNo
  accidentDetails: string
  accidentLocation: string
  occupation: string
  employerName: string
  annualIncome: string
  workImpact: WorkImpact
  driver: YesNo
  passenger: YesNo
  pedestrian: YesNo
  cyclist: YesNo
  motorcyclist: YesNo
  crashReportLodged: YesNo
  icwaAdmitted: YesNo
  insuranceCompany: string
  workersClaimLodged: YesNo
  claimAdmitted: YesNo
  receivingIncomePayments: YesNo
  otherDetails: string
}

export const initialCalculatorData: CalculatorFormData = {
  name: '',
  dateOfBirth: '',
  mobile: '',
  email: '',
  injuryDate: '',
  occurredInWA: '',
  injuries: '',
  surgery: '',
  accidentDetails: '',
  accidentLocation: '',
  occupation: '',
  employerName: '',
  annualIncome: '',
  workImpact: '',
  driver: '',
  passenger: '',
  pedestrian: '',
  cyclist: '',
  motorcyclist: '',
  crashReportLodged: '',
  icwaAdmitted: '',
  insuranceCompany: '',
  workersClaimLodged: '',
  claimAdmitted: '',
  receivingIncomePayments: '',
  otherDetails: '',
}

export interface CalculatorStepProps {
  data: CalculatorFormData
  update: <Key extends keyof CalculatorFormData>(
    key: Key,
    value: CalculatorFormData[Key],
  ) => void
}
